<template>
  <v-container fluid class="mb-6">
    <v-card outlined>
      <v-card-title>Authentication email permission activation</v-card-title>
      <v-card-text>
        <v-row justify="center" align="center">
          <v-col cols="6">
            <v-select
              v-model="toggle"
              :items="[
                {
                  text: 'ON',
                  value: true,
                },
                {
                  text: 'OFF',
                  value: false,
                },
              ]"
              label="Athentication email permission activation"
              outlined
              background-color="white"
              @change="updateToggle"
              :menu-props="{ bottom: true, offsetY: true }"
              hint="(*) Select ON to activate email permission"
              persistent-hint
            />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-card height="100%">
              <v-card-title>Whitelist</v-card-title>
              <v-card-text>
                <v-row dense justify="center" align="center">
                  <v-col cols="12" md="6">
                    <v-card outlined class="mx-auto">
                      <v-card-title> Mono email </v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-model.trim="newWhitelistEmail"
                          placeholder="Insert an user"
                          label="User input"
                          type="text"
                          outlined
                          clearable
                          class="mx-2"
                        ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="addToWhitelist({ uploadType: 'text' })"
                          :disabled="!newWhitelistEmail"
                        >
                          Add
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card outlined class="mx-auto">
                      <v-card-title>Multi email</v-card-title>
                      <v-card-text>
                        <v-file-input
                          v-model="file1"
                          color="primary accent-4"
                          counter
                          label="File input"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          placeholder="Select your file"
                          :append-icon="!file1 ? 'mdi-paperclip' : ''"
                          prepend-icon=""
                          outlined
                          :show-size="1000"
                          class="mx-2"
                        >
                          <template v-slot:selection="{ index, text }">
                            <v-chip
                              v-if="index < 2"
                              color="primary accent-4"
                              dark
                              label
                              small
                            >
                              {{ text }}
                            </v-chip>

                            <span
                              v-else-if="index === 2"
                              class="text-overline grey--text text--darken-3 mx-2"
                            >
                              +{{ file1.length - 2 }} File(s)
                            </span>
                          </template>
                        </v-file-input>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="handleUpload('whitelist_users')"
                          :disabled="file1 ? false : true"
                        >
                          Upload
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-data-table
                        :headers="headers"
                        :items="list1"
                        item-key="email"
                        class="elevation-1"
                        :search="search1"
                        :footer-props="{
                          'items-per-page-options': [10, 15, 20],
                          itemsPerPageText: $t('messanger.dash.footer'),
                        }"
                        :loading-text="$t('messanger.dash.loader')"
                        :loading="loader"
                      >
                        <template v-slot:no-results>
                          <v-alert
                            :value="true"
                            outlined
                            text
                            color="error"
                            icon="mdi-alert"
                            class="mt-4 text--center"
                            >{{
                              `${$t("users.dash.no_result")} '${search1}'`
                            }}</v-alert
                          >
                        </template>
                        <template v-slot:top>
                          <v-row no-gutters justify="center" align="center">
                            <v-col cols="8">
                              <v-text-field
                                v-model.trim="search1"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                              ></v-text-field>
                            </v-col>
                            <v-col cols="auto">
                              <v-btn
                                class="mx-4"
                                small
                                outlined
                                color="error"
                                @click="removeAllUsers('whitelist_users')"
                                :disabled="!list1.length"
                              >
                                <v-icon color="error" class="mx-1">
                                  mdi-delete
                                </v-icon>
                                Delete all
                                <v-icon color="warning" class="mx-1">
                                  mdi-alert
                                </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>

                        <template v-slot:item.action="{ item }">
                          <v-btn
                            small
                            rounded
                            color="error"
                            @click="removeEmail(item.user, 'whitelist_users')"
                          >
                            {{ $t("labellisation.custom.delete") }}
                            <v-icon size="17" class="ml-1"> mdi-delete </v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card height="100%">
              <v-card-title>Blacklist</v-card-title>
              <v-card-text>
                <v-row dense justify="center" align="center">
                  <v-col cols="12" md="6">
                    <v-card outlined class="ma-auto">
                      <v-card-title> Mono User </v-card-title>
                      <v-card-text>
                        <v-text-field
                          v-model.trim="newBlacklistEmail"
                          placeholder="Insert an user"
                          label="User input"
                          type="text"
                          outlined
                          clearable
                          class="mx-2"
                        ></v-text-field>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          :disabled="!newBlacklistEmail"
                          @click="addToBlacklist({ uploadType: 'text' })"
                          color="primary"
                        >
                          Add
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-card outlined class="ma-auto">
                      <v-card-title>Multi Users</v-card-title>
                      <v-card-text>
                        <v-file-input
                          v-model="file2"
                          color="primary accent-4"
                          counter
                          label="File input"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          placeholder="Select your file"
                          :append-icon="!file2 ? 'mdi-paperclip' : ''"
                          prepend-icon=""
                          outlined
                          :show-size="1000"
                          class="mx-2"
                        >
                          <template v-slot:selection="{ index, text }">
                            <v-chip
                              v-if="index < 2"
                              color="primary accent-4"
                              dark
                              label
                              small
                            >
                              {{ text }}
                            </v-chip>

                            <span
                              v-else-if="index === 2"
                              class="text-overline grey--text text--darken-3 mx-2"
                            >
                              +{{ file2.length - 2 }} File(s)
                            </span>
                          </template>
                        </v-file-input>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          @click="handleUpload('blacklist_users')"
                          :disabled="file2 ? false : true"
                        >
                          Upload
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-data-table
                        :headers="headers"
                        :items="list2"
                        item-key="email"
                        class="elevation-1"
                        :search="search2"
                        :footer-props="{
                          'items-per-page-options': [10, 15, 20],
                          itemsPerPageText: $t('messanger.dash.footer'),
                        }"
                        :loading-text="$t('messanger.dash.loader')"
                        :loading="loader"
                      >
                        <template v-slot:no-results>
                          <v-alert
                            :value="true"
                            outlined
                            text
                            color="error"
                            icon="mdi-alert"
                            class="mt-4 text--center"
                            >{{
                              `${$t("users.dash.no_result")} '${search2}'`
                            }}</v-alert
                          >
                        </template>
                        <template v-slot:top>
                          <v-row no-gutters justify="center" align="center">
                            <v-col cols="8">
                              <v-text-field
                                v-model.trim="search2"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                              ></v-text-field>
                            </v-col>
                            <v-col cols="auto">
                              <v-btn
                                class="mx-4"
                                small
                                outlined
                                color="error"
                                @click="removeAllUsers('blacklist_users')"
                                :disabled="!list2.length"
                              >
                                <v-icon color="error" class="mx-1">
                                  mdi-delete
                                </v-icon>
                                Delete all
                                <v-icon color="warning" class="mx-1">
                                  mdi-alert
                                </v-icon>
                              </v-btn>
                            </v-col>
                          </v-row>
                        </template>

                        <template v-slot:item.action="{ item }">
                          <v-btn
                            small
                            rounded
                            color="error"
                            @click="removeEmail(item.user, 'blacklist_users')"
                          >
                            {{ $t("labellisation.custom.delete") }}
                            <v-icon size="17" class="ml-1"> mdi-delete </v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import * as XLSX from "xlsx";

export default {
  name: "AuthOptionEmailList",
  data() {
    return {
      storeId: null,
      toggle: false,
      whitelist: [],
      blacklist: [],
      newWhitelistEmail: "",
      newBlacklistEmail: "",
      details: undefined,
      ////////////////////
      headers: [
        {
          text: "Users",
          align: "start",
          filterable: true,
          sortable: true,
          value: "user",
        },
        { text: "Action", align: "center", value: "action", sortable: false },
      ],
      search1: "",
      search2: "",
      loader: true,
      file1: null,
      file2: null,
    };
  },

  async mounted() {
    await this.fetch_store_config();
  },

  computed: {
    list1() {
      const list = this.not_display(this.whitelist);
      return list.map((user) => {
        return { user };
      });
    },

    list2() {
      const list = this.not_display(this.blacklist);
      return list.map((user) => {
        return { user };
      });
    },
  },

  methods: {
    async handleUpload(listType) {
      const file = listType === "whitelist_users" ? this.file1 : this.file2;
      if (!file) {
        console.error("No file selected");
        return;
      }

      // Validate file type
      const validExtensions = ["xlsx", "xls"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        console.error("Unsupported file type");
        this.showAlert(
          "Please upload a valid Excel file (.xlsx or .xls)",
          "error"
        );
        return;
      }

      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // Array of arrays
          this.excelData = jsonData;
          const users = jsonData.map((row) => row[0]).filter((user) => user);
          await this.handleSaveMultiUsers(users, listType);
        } catch (error) {
          console.error("Error parsing Excel file:", error);
          this.showAlert(
            "Failed to parse the Excel file. Please ensure it is correctly formatted.",
            "error"
          );
        }
      };

      reader.onerror = (error) => {
        console.error("Error reading file:", error);
        this.showAlert("error", "An error occurred while reading the file.");
      };

      // Start reading the file
      reader.readAsArrayBuffer(file);
    },
    async handleSaveMultiUsers(users, listType) {
      try {
        if (listType === "whitelist_users") {
          this.newWhitelistEmail = users;
          await this.addToWhitelist({ uploadType: "file" });
        } else {
          this.newBlacklistEmail = users;
          await this.addToBlacklist({ uploadType: "file" });
        }
      } catch (error) {
        console.error("Error saving multi users:", error);
        this.showAlert("Failed to save users. Please try again.", "error");
      }
    },

    not_display(list) {
      const restricted_emails = [
        "demo@phrolo.com",
        "olivierveran@inn-ov.fr",
        "j.lhuissier@cree.re",
        "gillesbaillachepro@gmail.com",
        "benjamin.chlon@orange.fr",
        "line.farah@sante.gouv.fr",
        "adrien.vaissade@cleed.com",
        "Careers@cleed.com ",
        "lahcen.saidi88@gmail.com",
      ];
      return list.filter((email) => !restricted_emails.includes(email));
    },

    async fetch_store_config() {
      try {
        this.$store.dispatch("setLoader", {
          showing: true,
          text: this.$t("messanger.dash.loader"),
        });
        this.loader = true;
        const res = await this.$store.dispatch("FETCH_STORE_CONFIG");
        this.details = res.response?.details;
        this.whitelist =
          res.response?.details?.authentication_options?.whitelist_users || [];
        this.blacklist =
          res.response?.details?.authentication_options?.blacklist_users || [];
        this.storeId = res.response.store_id;
        this.toggle = res.response?.details?.authentication_options_activation
          ? true
          : false;
        this.$store.dispatch("setLoader", {
          showing: false,
        });
        this.loader = false;
      } catch (error) {
        console.error("Failed to fetch store config:", error);
        this.$store.dispatch("setLoader", {
          showing: false,
        });
        this.loader = false;
      }
    },

    async addToWhitelist({ uploadType }) {
      if (this.newWhitelistEmail) {
        try {
          this.$store.dispatch("setLoader", {
            showing: true,
            text: this.$t("messanger.dash.loader"),
          });
          const response = await this.$store.dispatch("UPDATE_EMAIL_LIST", {
            users: this.newWhitelistEmail,
            listType: "whitelist_users",
            uploadType,
          });
          if (response?.final_list) {
            this.whitelist = response.final_list;
          }
          this.showAlert(
            response?.message || "Email added to blacklist successfully!",
            "success"
          );
          this.$store.dispatch("setLoader", {
            showing: false,
          });
          this.newWhitelistEmail = "";
          this.file1 = null;
        } catch (error) {
          console.error("Failed to add to blacklist:", error);
          this.showAlert(
            error?.data ||
              "Échec de l'ajout à la liste noire. Vérifiez l'adresse e-mail."
          );
          this.$store.dispatch("setLoader", {
            showing: false,
          });
          this.newWhitelistEmail = "";
          this.file1 = null;
        }
      }
    },

    async addToBlacklist({ uploadType }) {
      if (this.newBlacklistEmail) {
        try {
          this.$store.dispatch("setLoader", {
            showing: true,
            text: this.$t("messanger.dash.loader"),
          });
          const response = await this.$store.dispatch("UPDATE_EMAIL_LIST", {
            users: this.newBlacklistEmail,
            listType: "blacklist_users",
            uploadType,
          });
          if (response?.final_list) {
            this.blacklist = response.final_list;
          }
          this.showAlert(
            response?.message || "Email added to blacklist successfully!",
            "success"
          );
          this.$store.dispatch("setLoader", {
            showing: false,
          });
          this.newBlacklistEmail = "";
          this.file2 = null;
        } catch (error) {
          console.error("Failed to add to blacklist:", error);
          this.showAlert(
            error?.data ||
              "Échec de l'ajout à la liste noire. Vérifiez l'adresse e-mail."
          );
          this.$store.dispatch("setLoader", {
            showing: false,
          });
          this.newBlacklistEmail = "";
          this.file2 = null;
        }
      }
    },

    async removeAllUsers(listType) {
      try {
        const confirmation = await this.$store.dispatch("confirmer/ask", {
          title: this.$t("show_box.title"),
          body: `Do you confirm the deletion of all users in the ${listType}?`,
          ligth: false,
        });
        if (confirmation) {
          this.$store.dispatch("setLoader", {
            showing: true,
            text: this.$t("messanger.dash.loader"),
          });
          const response = await this.$store.dispatch("DELETE_ALL_EMAIL_LIST", {
            listType,
          });

          if (listType === "whitelist_users") {
            this.whitelist = [];
          } else {
            this.blacklist = [];
          }

          this.showAlert(
            response?.message || "All emails removed successfully!",
            "success"
          );
          this.$store.dispatch("setLoader", {
            showing: false,
          });
        }
      } catch (error) {
        console.error("Failed to remove all users:", error);
        this.showAlert(
          error?.data || "Erreur lors de la suppression de l'e-mail."
        );
        this.$store.dispatch("setLoader", {
          showing: false,
        });
      }
    },

    async removeEmail(user, listType) {
      const confirmation = await this.$store.dispatch("confirmer/ask", {
        title: this.$t("show_box.title"),
        body: "Do you confirm the deletion of this user?",
        ligth: false,
      });

      if (confirmation) {
        try {
          const response = await this.$store.dispatch("DELETE_EMAIL_LIST", {
            user,
            listType,
            storeId: this.storeId,
          });

          if (listType === "whitelist_users") {
            const index = this.whitelist.indexOf(user);
            if (index > -1) {
              this.whitelist.splice(index, 1);
            }
          } else {
            const index = this.blacklist.indexOf(user);
            if (index > -1) {
              this.blacklist.splice(index, 1);
            }
          }

          this.showAlert(
            response?.message || "user removed successfully!",
            "success"
          );
          this.$store.dispatch("setLoader", {
            showing: false,
          });
        } catch (error) {
          console.error("Failed to remove user:", error);
          this.showAlert(
            error?.data || "Erreur lors de la suppression de l'e-mail."
          );
          this.$store.dispatch("setLoader", {
            showing: false,
          });
        }
      }
    },

    async updateToggle() {
      const confirmation = await this.$store.dispatch("confirmer/ask", {
        title: this.$t("show_box.title"),
        body: "Confirm the activation of these emails",
        ligth: false,
      });
      if (confirmation) {
        try {
          this.details.authentication_options_activation = this.toggle;

          console.log("this.details", this.details);

          await this.$store.dispatch("UPDATE_STORE_CONFIG_DETAILS", {
            ...this.details,
          });
          this.showAlert("Email permission updated successfully!", "success");
        } catch (error) {
          console.error("Failed to update email toggle:", error);
          this.showAlert(
            error?.data || "Erreur lors de la mise à jour de l'e-mail."
          );
        }
      }
    },
    showAlert(message, type = "error") {
      this.$store.dispatch("setSnackbar", {
        text: message,
        color: type,
        top: true,
        timeout: 5000,
      });
    },
  },
};
</script>
